//@import dependencies
import React from 'react'
import {Link} from 'react-router-dom'
//@end

//@import components
import AllThingsModuleSkeleton from 'app_components/modules/academic/allthings/components/allThingsModuleSkeleton';
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import PaginationComponent from 'app_components/commons/pagination'
import OfferCardComponent from 'app_components/commons/offercard'

import ResearchCardComponent from 'app_components/commons/researchCard'
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import {IContentInterestItems} from 'app_types/campus/contentInterest/contentInterestTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../allthingsModule.scss'

// @ADD Component types
interface IAllthingsModuleLayoutProps {
	tags: Array<any>
  type: IContentInterestItems
  things: Array<any>
	loading: boolean
  pagination: IPagination
  onPageChange?: (page: number) => void
  onChangeTag?: (tag: any) => void
}

const AllthingsModuleLayout: React.FC<IAllthingsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const { windowWidth } = useWindowWidth()

  const { things } = props

  return(
    <div className='allthings-module--layout'>
      {props.loading ? (
        <AllThingsModuleSkeleton />
      ) : (
        <>
          {props.things && props.things.length > 0 ? (
            <>
            <div className="allthings-module--container-cards">
              {props.things.map((n) => (
                <div key={n.key}>
                  {n.link && !['webinar', 'capsules', 'research', 'journal', 'podcast'].includes(props.type) ? (
                    <Link to={routingService.getPublicPath(`${n.link}/${n.slug}`)}>
                      {['blog', 'webinar', 'research', 'journal', 'capsules', 'podcast'].includes(props.type) && (
                        <ResearchCardComponent
                          {...n}
                        />
                      )}
                      {['moocs'].includes(props.type) && (
                        <OfferCardComponent
                          course={n}
                          list={windowWidth < 767 ? true : false}
                        />
                      )}
                    </Link>
                  ) : (
                    <>
                      {['blog', 'research', 'journal'].includes(props.type) && (
                        <Link
                          to={{pathname: n?.researchUrl}}
                          target='_blank'
                        >
                          <ResearchCardComponent
                            {...n}
                          />
                        </Link>
                      )}
                      {['moocs'].includes(props.type) && (
                        <OfferCardComponent
                          course={n}
                          list={windowWidth < 767 ? true : false}
                        />
                      )}
                      {['webinar', 'capsules', 'podcast'].includes(props.type) && (
                        <ResearchCardComponent
                          {...n}
                          media={{
                            type: n?.video?.platform,
                            url: n?.video?.url,
                            name: n?.title,
                            description: n?.subtitle
                          }}
                        />
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
            {props.pagination && (
              <div className="row">
                <div className="col-12">
                  <PaginationComponent data={props.pagination} onChangePage={props.onPageChange} />
                </div>
              </div>
            )}
            </>
          ): (
            <div>
              <AlertComponent
                type='warning'
                title={t(`modules.content_interest.${props.type}.no_data`)}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AllthingsModuleLayout
